export const BEI_QUESTION_TEMPLATES = [
  'Tell me about a time you demonstrated strong {attribute} skills at work?',
  'Can you describe a professional situation where your {attribute} skills directly impacted the outcome?',
  'Give me an example of when you used your {attribute} skills to achieve a business or project goal?',
  'Walk me through a workplace challenge where {attribute} was essential to your success?',
  'Share a project you worked on where you relied heavily on your {attribute} skills?',
  'Describe a time at your job when your {attribute} skills helped you collaborate effectively with colleagues?',
  'Tell me about an assignment where your ability to apply {attribute} skills improved results?',
  'Give an example of how you used {attribute} skills to solve a problem in a professional setting?',
  'Can you walk me through a professional experience where your {attribute} skills were tested under pressure?',
  'Describe a situation in your role where using {attribute} skills helped you resolve a conflict or challenge?',
];

export const generateBEIQuestions = (attributes: string[]) => {
  const questions: { id: number; question: string; attribute: string }[] = [];

  attributes.forEach((attribute, attributeIndex) => {
    // Cycle through the 10 question templates (0-9), then repeat
    const templateIndex = attributeIndex % 10;
    const template = BEI_QUESTION_TEMPLATES[templateIndex];
    const questionId = attributeIndex + 1;
    const question = template.replace(/{attribute}/g, attribute.toLowerCase());

    questions.push({
      id: questionId,
      question,
      attribute,
    });
  });

  return questions;
};
